<template>
  <v-container grid-list-md fluid class="pa-0">
    <!-- <v-row>
      <v-col cols="12" class="pt-0">
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="px-0">
            <v-layout row wrap>
              <v-flex xs12 class="pa-2">
                <v-text-field
                class="pt-0"
                append-icon="mdi-account-search"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search by Subscription Desc, Frequency, Due-date etc.':'Search'"
                hide-details
                v-model="searchSubscription"
                outlined
                clearable
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="pa-1">
            <v-data-table
            :headers="subscriptionListHeader"
            :items="subscriptionListItems"
            hide-default-header
            hide-default-footer
            class="elevation-3"
            :mobile-breakpoint="0"
            disable-pagination
            fixed-header
            dense
            :search="searchSubscription"
            height="550px"
            >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th class="uniformchipinfo white--text" style="font-size: 13px; width: 50px; text-align: center ">{{headers[0].text}}</th>
                    <th class="uniformchipinfo white--text" style="font-size: 13px; width: 200px; text-align: center ">{{headers[1].text}}</th>
                    <th class="uniformchipinfo white--text" style="font-size: 13px; width: 250px; text-align: center ">{{headers[2].text}}</th>
                    <th class="uniformchipinfo white--text" style="font-size: 13px; width: 100px; text-align: left ">{{headers[3].text}}</th>
                    <th class="uniformchipinfo white--text" style="font-size: 13px; width: 100px; text-align: center ">{{headers[4].text}}</th>
                    <th class="uniformchipinfo white--text" style="font-size: 13px; width: 100px; text-align: right ">{{headers[5].text}}</th>
                    <th class="uniformchipinfo white--text" style="font-size: 13px; width: 100px; text-align: right ">{{headers[6].text}}</th>
                    <th class="uniformchipinfo white--text" style="font-size: 13px; width: 100px; text-align: right ">{{headers[7].text}}</th>
                  </tr>
                </thead>
              </template>
              <template slot="item" slot-scope="props">
                <tr @click="prepareUpdateSubscriptionsItem(props.item)">
                  <td style="text-align:center; font-size: 12px"> {{ props.index + 1 }} </td>
                  <td style="text-align:center; font-size: 12px"> {{ props.item.subs_description ? props.item.subs_description : '-' }} </td>
                  <td style="text-align:center; font-size: 12px"> {{ props.item.url ? props.item.url : '-' }} </td>
                  <td style="text-align:center; font-size: 12px"> {{ props.item.user_id ? props.item.user_id : '-' }} </td>
                  <td style="text-align:center; font-size: 12px"> {{ props.item.user_pwd ? props.item.user_pwd : '-' }} </td>
                  <td style="text-align:center; font-size: 12px"> {{ props.item.pay_freq ? props.item.pay_freq : '-' }} </td>
                  <td style="text-align:center; font-size: 12px"> {{ props.item.due_date ? handy.formatDate(props.item.due_date) : '-' }} </td>
                  <td style="text-align:center; font-size: 12px"> {{ props.item.status ? props.item.status : '-' }} </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row> -->
    <v-layout class="pa-0" row wrap>
      <v-flex xs12 mx-auto>
        <v-flex xs12>
          <v-card flat>
            <v-card-title class="px-0 py-0">
              <v-text-field
              class="pt-0"
              append-icon="mdi-account-search"
              :placeholder="$vuetify.breakpoint.smAndUp?'Search by Subscription Desc, Frequency, Due-date etc.':'Search'"
              hide-details
              v-model="searchSubscription"
              outlined
              clearable
              ></v-text-field>
            </v-card-title>
            <v-card-text class="px-0 pt-2">
              <v-data-table
              :headers="subscriptionListHeader"
              :items="lSubscriptionListItems"
              hide-default-header
              hide-default-footer
              class="elevation-3"
              :mobile-breakpoint="0"
              disable-pagination
              fixed-header
              dense
              :search="searchSubscription"
              height="550px"
              >
                <template v-slot:header="{ props: { headers } }">
                  <thead>
                    <tr>
                      <th class="uniformchipinfo white--text" style="font-size: 13px; width: 50px; text-align: center ">{{headers[0].text}}</th>
                      <th class="uniformchipinfo white--text" style="font-size: 13px; width: 200px; text-align: center ">{{headers[1].text}}</th>
                      <th class="uniformchipinfo white--text" style="font-size: 13px; width: 250px; text-align: center ">{{headers[2].text}}</th>
                      <th class="uniformchipinfo white--text" style="font-size: 13px; width: 100px; text-align: left ">{{headers[3].text}}</th>
                      <th class="uniformchipinfo white--text" style="font-size: 13px; width: 100px; text-align: center ">{{headers[4].text}}</th>
                      <th class="uniformchipinfo white--text" style="font-size: 13px; width: 100px; text-align: center ">{{headers[5].text}}</th>
                      <th class="uniformchipinfo white--text" style="font-size: 13px; width: 100px; text-align: center ">{{headers[6].text}}</th>
                      <th class="uniformchipinfo white--text" style="font-size: 13px; width: 100px; text-align: center ">{{headers[7].text}}</th>
                    </tr>
                  </thead>
                </template>
                <template slot="item" slot-scope="props">
                  <tr @click="prepareUpdateSubscriptionsItem(props.item)">
                    <td style="text-align:center; font-size: 12px"> {{ props.index + 1 }} </td>
                    <td style="text-align:center; font-size: 12px"> {{ props.item.subs_description ? props.item.subs_description : '-' }} </td>
                    <td style="text-align:center; font-size: 12px"> {{ props.item.url ? props.item.url : '-' }} </td>
                    <td style="text-align:left; font-size: 12px"> {{ props.item.user_id ? props.item.user_id : '-' }} </td>
                    <td style="text-align:center; font-size: 12px"> {{ props.item.user_pwd ? props.item.user_pwd : '-' }} </td>
                    <td style="text-align:center; font-size: 12px"> {{ props.item.pay_freq ? props.item.pay_freq : '-' }} </td>
                    <td style="text-align:center; font-size: 12px"> {{ props.item.due_date ? handy.formatDate(props.item.due_date) : '-' }} </td>
                    <td style="text-align:center; font-size: 12px"> {{ props.item.status ? props.item.status : '-' }} </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-flex>
    </v-layout>

    <!-- 1. Create / update payroll processing base -->
    <v-dialog v-model="showCreateSubscriptionsItem" persistent scrollable max-width="600px">
      <v-form ref="pForm" @submit.prevent="saveSubscriptionsItem(lAction)">
        <v-card>
          <v-card-title class="py-2 grey lighten-4">
            {{ handy.startWithUpper(lAction) }} Subscriptions Item
          </v-card-title>
          <v-card-text class="pt-1 pb-2">
            <v-flex xs12 class="pa-2">
              <v-layout row wrap>
                <v-flex xs12 class="pa-1">
                  <v-text-field
                  v-model="lSubscriptionItem.subs_description"
                  label="Subscription Description"
                  hide-details
                  style="font-size: 14px"
                  :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 class="pa-1">
                  <v-text-field
                  v-model="lSubscriptionItem.url"
                  label="Subscription URL"
                  hide-details
                  style="font-size: 14px"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 class="pa-1">
                  <v-text-field
                  v-model="lSubscriptionItem.user_id"
                  label="User Id"
                  hide-details
                  style="font-size: 14px"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 class="pa-1">
                  <v-text-field
                  v-model="lSubscriptionItem.user_pwd"
                  label="User Password"
                  hide-details
                  style="font-size: 14px"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="pa-1 pt-4">
                  <v-autocomplete
                  v-model="lSubscriptionItem.pay_freq"
                  :items="freq_list"
                  label="Frequency"
                  dense
                  hide-details
                  :rules="[rules.required]"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4 class="pa-1">
                  <v-dialog ref="dlgDueDate"
                  persistent v-model="dlgDueDate"
                  max-width="290px"
                  :return-value.sync="lSubscriptionItem.due_date">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                      slot="activator" label="Due Date"
                      v-model="lSubscriptionItem.due_date" append-icon="mdi-calendar-today"
                      readonly clearable
                      :rules="[rules.required]"
                      v-on="on"
                      hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="lSubscriptionItem.due_date"
                    first-day-of-week="1">
                      <v-spacer></v-spacer>
                      <v-btn text @click="dlgDueDate = false">Cancel</v-btn>
                      <v-btn text color="accent" @click="$refs.dlgDueDate.save(lSubscriptionItem.due_date)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs4 class="pa-1">
                  <v-autocomplete
                  v-model="lSubscriptionItem.status"
                  :items="status_list"
                  label="Status"
                  hide-details
                  style="font-size: 14px"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 class="pa-1">
                  <v-textarea
                  v-model="lSubscriptionItem.remarks"
                  label="Add Remarks if any?"
                  hide-details
                  maxlength="1000"
                  style="font-size: 14px"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-text>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn small @click="closeSubscriptionItemAddDialog()">close</v-btn>
            <v-btn small class="accent" v-if="config.IS_EDITED_BY_USER" type="submit">save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-btn :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
    dark fab fixed color="accent" v-if="lAction === 'view' && config.IS_EDITED_BY_USER"
    @click.native="prepareCreate"><v-icon>mdi-playlist-plus</v-icon></v-btn>

    <!-- snack bar for reporting -->
    <v-snackbar :color="sbarCol" v-model="sbar"
    :timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // common
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      search: '',
      lAction: 'view',
      handy: handy,
      config: config,
      rules: handy.rules,
      beingSaved: false,
      searchSubscription: '',
      subscriptionListHeader: [
        { text: 'S.No', value: '', sortable: false },
        { text: 'Subscription Desc', value: 'subs_description', sortable: false },
        { text: 'URL', value: 'url', sortable: false },
        { text: 'User Name', value: 'user_id', sortable: false },
        { text: 'Password', value: 'user_pwd', sortable: false },
        { text: 'Frequency', value: 'pay_freq', sortable: false },
        { text: 'Due Date', value: 'due_date', sortable: false },
        { text: 'Status', value: 'base_status', sortable: false }
      ],
      lSubscriptionListItems: [],
      lSubscriptionItem: [],
      dlgDueDate: false,
      status_list: ['Active', 'In-Active'],
      freq_list: ['Monthly', 'Quarterly', 'Half-Yearly', 'Yearly', 'As on Required' ],
      showCreateSubscriptionsItem: false,

    }
  },
  created () {
    this.loadSubscriptionsList()
    this.lAction = 'view'
  },
  mounted () {

  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadSubscriptionsList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.lSubscriptionListItems = []
      this.axios.get(config.API_URL + '/getlSubscriptionListItems/', qry)
      .then(response => {
        this.lSubscriptionListItems = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCreate () {
      this.lSubscriptionItem = {
        payroll_process_base_id: null,
        subs_description: '',
        url: '',
        user_id: '',
        user_pwd: '',
        pay_freq: 'Monthly',
        due_date: null,
        status: 'Active',
        remarks: '',
        vendor_id: config.VENDOR_ID
      }
      // this.lSubscriptionListItems = []
      this.showCreateSubscriptionsItem = true
      this.lAction = 'create'
    },
    closeSubscriptionItemAddDialog () {
      this.showCreateSubscriptionsItem = false
      this.lAction = 'view'
    },
    saveSubscriptionsItem (action) {
      if (this.lSubscriptionItem.subs_description && this.lSubscriptionItem.pay_freq && this.lSubscriptionItem.status) {
        this.lSubscriptionItem.vendor_id = config.VENDOR_ID
        this.axios.post(config.API_URL + '/subscriptions/' + action, this.lSubscriptionItem)
        .then(response => {
          this.loadSubscriptionsList()
          this.msg('Saved Successfully', 1)
          this.showCreateSubscriptionsItem = false
          this.lAction = 'view'
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please enter all mandatory fields', 0)
      }
    },
    prepareUpdateSubscriptionsItem (curRec) {
      this.lSubscriptionItem = Object.assign({}, curRec)
      this.lSubscriptionItem.due_date = curRec.due_date ? handy.formatDBDate(curRec.due_date) : null
      this.lAction = 'update'
      this.showCreateSubscriptionsItem = true
    },

  }
}
</script>

<style lang="scss">
.importtabletd.v-data-table td{
  font-weight:normal;
  font-size:12px !important;
}
.importtableth.v-data-table th{
  font-weight:bold;
  font-size:12px !important;
}
.my-label-text-size .v-label {
  font-size: 12px !important;
}
</style>
